module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-start-selling-flower-f08988f15c547f95780229a08ccfc24a.png";